import {Component, Inject} from '@angular/core';
import {StatePersistenceService} from '../service/state.persistence.service';
import {DOCUMENT} from '@angular/common';
import {Meta, Title} from '@angular/platform-browser';
import {UtilitiesService} from '../service/utilities.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {BreadcrumbService} from '../service/breadcrumb.service';
import {filter} from 'rxjs/operators';
import {BaseComponent} from '../common/component/base/base.component';

const selector: string = 'secure';

@Component({
    selector: selector,
    templateUrl: './secure.component.html',
    styleUrls: ['./secure.component.scss']
})
export class SecureComponent extends BaseComponent {

    activated: boolean;

    constructor(@Inject(DOCUMENT) public override document: Document,
                private title: Title,
                private meta: Meta,
                private utilities: UtilitiesService,
                private state: StatePersistenceService,
                private route: ActivatedRoute,
                router: Router,
                breadcrumbService: BreadcrumbService) {
        super(document, router, breadcrumbService);
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: any): void => {
            const url: string = event.url;
            this.activated = (url.substring(url.lastIndexOf('/') + 1) === selector);
        });
    }
}
